import SplitterRoot from './Splitter';
import Panel from './Panel';
const Splitter = SplitterRoot;
Splitter.Panel = Panel;
Splitter.install = function (app) {
    app.component(SplitterRoot.name, SplitterRoot);
    app.component(Panel.name, Panel);
    return app;
};
export { Panel as SplitterPanel };
export default Splitter;
